// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false,
//   apiUrl: 'http://localhost:3000/',
//   firebaseConfig: {
//     apiKey: "AIzaSyAReSFLqM4BpqL1LTb3AatUz9Y4yoZ0Z6E",
//     authDomain: "trasllapp.firebaseapp.com",
//     databaseURL: "https://trasllapp.firebaseio.com",
//     projectId: "trasllapp",
//     storageBucket: "trasllapp.appspot.com",
//     messagingSenderId: "632459296936",
//     appId: "1:632459296936:web:c7c0d2dbe0b584fac2029d",
//     measurementId: "G-88P0J4E3ME"

//     // apiKey: "AIzaSyA13VBY5CXfgUT97rKTzHmwZ1VqsO_0dcU",
//     // authDomain: "trasllapp-dev.firebaseapp.com",
//     // projectId: "trasllapp-dev",
//     // storageBucket: "trasllapp-dev.appspot.com",
//     // messagingSenderId: "549228216062",
//     // appId: "1:549228216062:web:b2f39c680552dd092f6faf"

//   },
//   mapboxAccessToken: 'pk.eyJ1IjoiamFydmlzMDU0NSIsImEiOiJjazhnbnA5ZW0wM2ZsM251ZHo0Z2NicWZsIn0.xde7f87wfeQ-g745EDP1MQ',
//   mapboxDirectionAPI: {
//     url: 'https://api.mapbox.com/directions/v5/mapbox/driving/',
//     geojson: 'geometries=geojson&'
//   }
// };

export const environment = {
  production: true,
  apiUrl: 'https://trasllapp-api-backend-dev.herokuapp.com/',
  firebaseConfig: {
    apiKey: "AIzaSyAReSFLqM4BpqL1LTb3AatUz9Y4yoZ0Z6E",
    authDomain: "trasllapp.firebaseapp.com",
    databaseURL: "https://trasllapp.firebaseio.com",
    projectId: "trasllapp",
    storageBucket: "trasllapp.appspot.com",
    messagingSenderId: "632459296936",
    appId: "1:632459296936:web:c7c0d2dbe0b584fac2029d",
    measurementId: "G-88P0J4E3ME"
    // apiKey: "AIzaSyA13VBY5CXfgUT97rKTzHmwZ1VqsO_0dcU",
    // authDomain: "trasllapp-dev.firebaseapp.com",
    // projectId: "trasllapp-dev",
    // storageBucket: "trasllapp-dev.appspot.com",
    // messagingSenderId: "549228216062",
    // appId: "1:549228216062:web:b2f39c680552dd092f6faf"

  },
  mapboxAccessToken: 'pk.eyJ1IjoiamFydmlzMDU0NSIsImEiOiJjazhnbnA5ZW0wM2ZsM251ZHo0Z2NicWZsIn0.xde7f87wfeQ-g745EDP1MQ',
  mapboxDirectionAPI: {
    url: 'https://api.mapbox.com/directions/v5/mapbox/driving/',
    geojson: 'geometries=geojson&'
  }
};
